import qs from 'qs';

import { client } from '@api/client';
import { URL } from '@api/urls';

import {
	IAllCellsDTO,
	IUpdateCellLimenetDTO,
	TCleanCellLimenetDTO,
} from '@interfaces/cells/dto/cellsDTO';
import { ISiteProfile } from '@interfaces/cells/siteProfile';
import { IItemsResponse } from '@interfaces/common/response';

const {
	cell4GFdd,
	cell4GTdd,
	cell5G,
	crowdCells,
	limenet,
	clean,
} = URL;

export const updateCell4GFddLimenet = ({ id, dto, cellId, timestamp }: IUpdateCellLimenetDTO): Promise<void> =>
	client.put(`${crowdCells}/${limenet}/${id}/${cell4GFdd}/${cellId}`, { dto, timestamp });

export const updateCell4GTddLimenet = ({ id, dto, cellId, timestamp }: IUpdateCellLimenetDTO): Promise<void> =>
	client.put(`${crowdCells}/${limenet}/${id}/${cell4GTdd}/${cellId}`, { dto, timestamp });

export const updateCell5GLimenet = ({ id, dto, cellId, timestamp }: IUpdateCellLimenetDTO): Promise<void> =>
	client.put(`${crowdCells}/${limenet}/${id}/${cell5G}/${cellId}`, { dto, timestamp });

export const cleanCell4GFddLimenet = ({ id, cellId, timestamp }: TCleanCellLimenetDTO): Promise<void> =>
	client.put(`${crowdCells}/${limenet}/${id}/${cell4GFdd}/${cellId}${clean}`, null, { params: { timestamp } });

export const cleanCell4GTddLimenet = ({ id, cellId, timestamp }: TCleanCellLimenetDTO): Promise<void> =>
	client.put(`${crowdCells}/${limenet}/${id}/${cell4GTdd}/${cellId}${clean}`, null, { params: { timestamp } });

export const cleanCell5GLimenet = ({ id, cellId, timestamp }: TCleanCellLimenetDTO): Promise<void> =>
	client.put(`${crowdCells}/${limenet}/${id}/${cell5G}/${cellId}${clean}`, null, { params: { timestamp } });

export const getAllCells4GFddLimenet = (data: IAllCellsDTO): Promise<IItemsResponse<ISiteProfile>> => {
	return client.get(`${crowdCells}/${limenet}/${cell4GFdd}/filter`, {
		params: {
			...data,
		},
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};

export const getAllCells4GTddLimenet = (data: IAllCellsDTO): Promise<IItemsResponse<ISiteProfile>> => {
	return client.get(`${crowdCells}/${limenet}/${cell4GTdd}/filter`, {
		params: {
			...data,
		},
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};

export const getAllCells5GLimenet = (data: IAllCellsDTO): Promise<IItemsResponse<ISiteProfile>> => {
	return client.get(`${crowdCells}/${limenet}/${cell5G}/filter`, {
		params: {
			...data,
		},
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};
